import {SharingSettingsTypes} from '../../../models';

export enum ENTITY_TYPE {
  DATABASE = SharingSettingsTypes.DATABASE,
  INTEGRATION = SharingSettingsTypes.INTEGRATION,
  REPORT = SharingSettingsTypes.REPORT,
}
